<template>
    <div>
        <v-dialog v-model="open" persistent max-width="400" scrollable>
            <v-card>
                <v-card-text style="max-height: 600px;" class="py-0">
                    <v-form ref="form" class="text-center">
                        <v-card flat>
                            <v-card-text>
                                <v-row class="py-6">
                                    <v-col cols="12" class="py-0 px-6 text-subtitle-1">
                                        ¿Desea eliminar este usuario?
                                    </v-col>
                                    <v-col v-if="error != ''" class="pa-0 red--text">
                                        {{ error }}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-btn 
                                            :loading="loading"
                                            block 
                                            color="red darken-3 white--text"
                                            @click="confirmDelete"
                                            > Eliminar </v-btn>

                                    </v-col>
                                    <v-col cols="12">
                                        <v-btn
                                            color="blue-grey"
                                            text
                                            block
                                            @click="close"
                                            >Cancelar</v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { LEVEL_ADMIN } from '../../plugins/checkPermission.js'
import { mapActions, mapGetters } from 'vuex'
export default {
    name: 'formDelete',
    props: ['open', 'user'],
    computed:{
        ...mapGetters({
            getUser: 'account/getUser', 
            admins: 'account/getUsersAdmin'
        })
    },
    data() {
        return {
            loading: false,
            password: null,
            error: null,
            LEVEL_ADMIN
        }
    },
    methods: {
        ...mapActions({ deleteUser: 'account/deleteUser' }),
        async confirmDelete(){
            try {
                this.loading = true
                const user = this.getUser(this.user)
                if(user.level === LEVEL_ADMIN && this.admins.length <= 1){
                    this.error = 'Debe haber al menos otro usuario administrador'
                    setTimeout(this.hideError, 3000)
                    this.loading = false
                    return
                }
                
                await this.deleteUser(this.user)
                this.loading = false
                this.close()
            } catch (error) {
                this.error = error
                setTimeout(this.hideError, 3000)
            }
        },
        hideError(){
            this.error = null
        },
        close(){
            this.password = null
            this.$emit('close')
        }
    },
}
</script>